import { gql } from '@apollo/client'

export const CHANGE_USER_ACCOUNT_DETAILS = gql`
  mutation ChangeUserAccountDetails($input: ChangeUserAccountDetailsInput!) {
    changeUserAccountDetails(input: $input)
  }
`

export const CREATE_PLACE_FOR_BUSINESS_CUSTOMER = gql`
  mutation CreatePlaceForBusinessCustomer($input: CreatePlaceForBusinessCustomerInput!) {
    createPlaceForBusinessCustomer(input: $input)
  }
`

export const CREATE_BUSINESS_CUSTOMER = gql`
  mutation CreateBusinessCustomer($input: CreateBusinessCustomerInput!) {
    createBusinessCustomer(input: $input)
  }
`

export const CREATE_BUSINESS_CUSTOMERS_FROM_CSV = gql`
  mutation CreateBusinessCustomersFromCSV($input: CreateBusinessCustomersFromCSVInput!) {
    createBusinessCustomersFromCSV(input: $input)
  }
`

export const ACTIVATE_BUSINESS_CUSTOMER = gql`
  mutation ActivateBusinessCustomer($input: EnableBusinessCustomerInput!) {
    enableBusinessCustomer(input: $input)
  }
`

export const DEACTIVATE_BUSINESS_CUSTOMER = gql`
  mutation DeactivateBusinessCustomer($input: DisableBusinessCustomerInput!) {
    disableBusinessCustomer(input: $input)
  }
`
export const REQUEST_RESET_USER_ACCOUNT_PASSWORD = gql`
  mutation RequestResetUserAccountPassword($input: RequestResetUserAccountPasswordInput!) {
    requestResetUserAccountPassword(input: $input)
  }
`
export const UNASSIGN_BUSINESS_CUSTOMER_CORPORATE_CREDITS = gql`
  mutation UnassignBusinessCustomerKreditCategory($input: UnassignBusinessCustomerKreditCategoryInput!) {
    unassignBusinessCustomerKreditCategory(input: $input)
  }
`
export const ASSIGN_BUSINESS_CUSTOMER_KREDIT_CATEGORY = gql`
  mutation AssignBusinessCustomerKreditCategory($input: AssignBusinessCustomerKreditCategoryInput!) {
    assignBusinessCustomerKreditCategory(input: $input)
  }
`
export const CHANGE_BUSINESS_CLIENT_CUSTOMER_KREDITS_AMOUNT = gql`
  mutation ChangeBusinessClientCustomerKreditsAmount($input: ChangeBusinessClientCustomerKreditsAmountInput!) {
    changeBusinessClientCustomerKreditsAmount(input: $input)
  }
`
export const ASSIGN_BUSINESS_CUSTOMERS_KREDIT_CATEGORY = gql`
  mutation AssignBusinessCustomersKreditCategory($input: AssignBusinessCustomersKreditCategoryInput!) {
    assignBusinessCustomersKreditCategory(input: $input)
  }
`
export const CHANGE_BUSINESS_BULK_CUSTOMER_KREDITS_AMOUNT = gql`
  mutation ChangeBusinessClientCustomerKreditsAmount($input: ChangeBusinessClientCustomersKreditsAmountInput!) {
    changeBusinessClientCustomersKreditsAmount(input: $input)
  }
`

export const CHANGE_BUSINESS_CUSTOMER_BUSINESS_SITE = gql`
  mutation ChangeBusinessCustomerBusinessSite($input: ChangeBusinessCustomerBusinessSiteInput!) {
    changeBusinessCustomerBusinessSite(input: $input)
  }
`

export const REPLACE_PLACE_FOR_BUSINESS_CUSTOMER = gql`
  mutation ReplacePlaceForBusinessCustomer($input: ReplacePlaceForBusinessCustomerInput!) {
    replacePlaceForBusinessCustomer(input: $input)
  }
`
